import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, FormGroup, Label, Button, } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import './EnterpriseInsights.css';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import AllFarmMap from '../EnterpriseInsights/AllFarmMap';
import ProgrammeSummary from '../EnterpriseInsights/ProgrammeSummary';
import AllFarmRiparianPlantingSummary from './AllFarmRiparianPlantingSummary';
import AllFarmForestryandBushArea from './AllFarmForestryandBushArea';
import AllFarmWaterwayFencingSummary from './AllFarmWaterwayFencingSummary';
import OrganisationSummary from './OrganisationSummary';
import GFPSummaryReport from './GFPSummaryReport';
import Select, { components } from 'react-select';


const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const EnterpriseInsights = ({ handleWizardFarmChanged }) => {
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); 
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [catchmentSelect, setCatchmentSelect] = useState([]); const [regionalCouncilSelect, setRegionalCouncilSelect] = useState([]);
    const [loading, setLoading] = useState(true);
    const [enterpriseInsights, setEnterpriseInsights] = useState({ farmsList: [], itemList: [], programmeSummary: {}, openActionSupplierList: [], openActionList: [], openActionsList: [], totalFarmDetails: {}, isOrganisationAdmin :false});
    const [isGFPSummaryReportVisible, setIsGFPSummaryReportVisible] = useState(false); const [catchments, setCatchments] = useState([]); const [regionalCouncils, setRegionalCouncils] = useState([]);
    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        try {
            const response = await axios.get(
                '/api/EnterpriseInsights/GetEnterpriseInsightsDetails/', {
                    params: { UserId: userId, CatchmentSelected: '0', RegionalCouncilSelected: '0' }
            }
            );
            setEnterpriseInsights({
                ...enterpriseInsights, farmsList: response.data.farmsList, programmeSummary: response.data.programmeSummary
                , openActionSupplierList: response.data.openActionSupplierList, openActionList: response.data.openActionList, openActionsList: response.data.openActionsList
                , totalFarmDetails: response.data.totalFarmDetails, itemList: response.data.allFarmOutlineList, allActionsList: response.data.allActionsList, actionYearList: response.data.actionYearList,
                programmeSummaryFarmsList: response.data.farmsList, isOrganisationAdmin: response.data.isOrganisationAdmin
            });
            setIsGFPSummaryReportVisible(response.data.isGFPSummaryReportVisible);
            setCatchments(response.data.catchments);
            setRegionalCouncils(response.data.regionalCouncils);
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }
    const handleCatchmentChange = async (event) => {
        setCatchmentSelect(event);
    }
    const handleRegionalCouncilChange = async (event) => {
        setRegionalCouncilSelect(event);
    }
    const handleApplyFilter = async (e) => {
        setLoading(true);
        let catchments = '';
        if (Array.isArray(catchmentSelect)) {
            let catchmentArr = [];
            catchmentSelect.forEach(type => {
                catchmentArr.push(type.value);
            })
            catchments = catchmentArr.join(",");
        }
        else if (typeof catchmentSelect === 'object' && catchmentSelect.constructor === Object) {
            catchments = catchmentSelect.value.toString();
        }
        else {
            catchments = catchmentSelect.toString();
        }
        let regionalCouncils = '';
        if (Array.isArray(regionalCouncilSelect)) {
            let regionalCouncilArr = [];
            regionalCouncilSelect.forEach(type => {
                regionalCouncilArr.push(type.value);
            })
            regionalCouncils = regionalCouncilArr.join(",");
        }
        else if (typeof regionalCouncilSelect === 'object' && regionalCouncilSelect.constructor === Object) {
            regionalCouncils = regionalCouncilSelect.value.toString();
        }
        else {
            regionalCouncils = regionalCouncilSelect.toString();
        }

        try {
            const response = await axios.get(
                '/api/EnterpriseInsights/GetEnterpriseInsightsDetails/', {
                    params: { UserId: userId, CatchmentSelected: catchments == '' ? '0' : catchments, RegionalCouncilSelected: regionalCouncils == '' ? '0' : regionalCouncils }
            }
            );
            setEnterpriseInsights({
                ...enterpriseInsights, farmsList: response.data.farmsList, programmeSummary: response.data.programmeSummary
                , openActionSupplierList: response.data.openActionSupplierList, openActionList: response.data.openActionList, openActionsList: response.data.openActionsList
                , totalFarmDetails: response.data.totalFarmDetails, itemList: response.data.allFarmOutlineList, allActionsList: response.data.allActionsList, actionYearList: response.data.actionYearList,
                programmeSummaryFarmsList: response.data.farmsList
            });
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }
    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h2>Enterprise Insights</h2></Col>
            </Row>
            <br />
            <Row>
                <Col sm="1"><h6>Filter by: </h6></Col>
                <Col sm="3">
                    <FormGroup>
                        <Label className="label" for="catchmentSelect">Catchment</Label>
                        {catchments == undefined && <p><em>Loading...</em></p>}
                        {catchments != undefined && catchments.length > 0 &&
                            <Select
                                id="catchmentSelect" isMulti width="max-content"
                                name="catchmentSelect"
                                closeMenuOnSelect={false}
                                className="dropdown"
                                placeholder="Select Catchment"
                                value={catchmentSelect}
                                options={catchments}
                                onChange={handleCatchmentChange}
                                isClearable hideSelectedOptions={false}
                                components={{
                                    Option
                                }}
                            />
                        }
                    </FormGroup>
                </Col>
                <Col sm="3">
                    <FormGroup>
                        <Label className="label" for="regionalCouncilSelect">Regional Council</Label>
                        {catchments == undefined && <p><em>Loading...</em></p>}
                        {catchments != undefined && catchments.length > 0 &&
                            <Select
                                id="regionalCouncilSelect" isMulti width="max-content"
                                name="regionalCouncilSelect"
                                closeMenuOnSelect={false}
                                className="dropdown"
                                placeholder="Select Regional Council"
                                value={regionalCouncilSelect}
                                options={regionalCouncils}
                                onChange={handleRegionalCouncilChange}
                                isClearable hideSelectedOptions={false}
                                components={{
                                    Option
                                }}
                            />
                        }
                    </FormGroup>
                </Col>
                <Col sm="2">
                    <br />
                    <Button style={{ float: "right" }} color="success" onClick={(e) => handleApplyFilter(e)} value="Apply Filter" placeholder="">
                        Apply Filter
                    </Button>
                </Col>
            </Row>
            {loading ? <SpinnerContainer /> :
                <div>
                    <Row>
                        <Col sm="5">
                            <ProgrammeSummary actionYearList={enterpriseInsights.actionYearList} allActionsList={enterpriseInsights.allActionsList}
                                programmeSummary={enterpriseInsights.programmeSummary} farmsList={enterpriseInsights.programmeSummaryFarmsList}></ProgrammeSummary> <br />
                            {
                                isGFPSummaryReportVisible && <GFPSummaryReport></GFPSummaryReport>
                            }
                            <AllFarmRiparianPlantingSummary></AllFarmRiparianPlantingSummary>
                        </Col>
                        <Col sm="7">
                            <AllFarmMap itemModel={enterpriseInsights}></AllFarmMap>
                            {enterpriseInsights.isOrganisationAdmin && 
                                <OrganisationSummary></OrganisationSummary>    
                            }
                            <AllFarmWaterwayFencingSummary></AllFarmWaterwayFencingSummary>
                            <AllFarmForestryandBushArea></AllFarmForestryandBushArea>
                        </Col>
                    </Row>
                </div>
            }
        </div>
    )
}
export default EnterpriseInsights;